<template>
  <div class="edit-content mb-5">
    <div class="container padding-top-90">
      <div class="row mb-3">
        <div class="col-auto">
          <div class="form-group">
            <fieldset :disabled="creating">
              <select name="selectedEvent" class="form-control" v-model="selectedEvent" @change="selectedEventChanged">
                <option :value="null">Select event</option>
                <option :value="event.id" v-for="event in events" :key="`eventSelect-${event.id}`">{{ event.header }}</option>
              </select>
            </fieldset>
          </div>
        </div>
      </div>

      <div class="row" v-if="currentEvent" :key="selectedEvent">
        <div class="col-12">
          <form name="form" @submit.prevent="updateContent">
            <div class="form-group">
              <label for="header">Header</label>
              <input type="text" name="header" id="header" v-model="currentEvent.header" class="form-control">
            </div>

            <div class="form-group">
              <label for="subHeader">Sub header</label>
              <input type="text" name="subHeader" id="subHeader" v-model="currentEvent.subHeader" class="form-control">
            </div>

            <div class="form-group">
              <label for="eventStart">Event start</label>
              <input type="text" name="eventStart" id="eventStart" v-model="currentEvent.eventStart" class="form-control">
            </div>

            <div class="form-group">
              <label for="streamUrl">Stream URL</label>
              <input type="text" name="streamUrl" id="streamUrl" v-model="currentEvent.streamUrl" class="form-control">
            </div>

            <div class="form-group">
              <label for="image">Image</label>
              <input type="text" name="image" id="image" v-model="currentEvent.image" class="form-control">
            </div>

            <div class="form-group">
              <label for="contentDefault">Content - Default</label>
              <editor v-model="currentEvent.contentDefault"></editor>
            </div>

            <div class="form-group">
              <label for="contentSignedIn">Content - Signed in</label>
              <editor v-model="currentEvent.contentSignedIn"></editor>
            </div>

            <div class="form-group">
              <label for="contentAgenda">Agenda</label>
              <editor v-model="currentEvent.contentAgenda"></editor>
            </div>

            <button type="submit" name="submit" class="btn btn-primary">Save</button>
            <span class="d-inline-block ml-3 text-success" v-if="message">{{ message }}</span>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Editor from "@/components/editor"
  import { firebase } from "@/initializers/firebase"

  export default {
    name: "edit-content",
    components: { Editor },
    beforeRouteEnter(to, from, next) {
      if(to.query.showme) {
        next()
      } else {
        next({ name: "home" })
      }
    },
    data() {
      return {
        loading: true,
        creating: false,
        message: null,
        events: [],
        selectedEvent: null,
        currentEvent: null
      }
    },
    computed: {
      event() {
        return this.events.find((event) => event.id == this.selectedEvent)
      },
      eventStartAsISOString() {
        return this.currentEvent.eventStart.toDate()
      },
      contentDefaultEditor() {
        return new Editor({
          content: this.currentEvent.contentDefault
        })
      }
    },
    methods: {
      selectedEventChanged() {
        let event = this.events.find((event) => event.id == this.selectedEvent)
        let object = {}

        let startDateISO = this.event.eventStart.toDate().toISOString()
        object.eventStart = startDateISO

        this.currentEvent = Object.assign({}, event, object)
      },
      async updateContent() {
        let event = Object.assign({}, this.currentEvent)
        let eventStartDate = new Date(event.eventStart)
        let timestamp = await firebase.firestore.Timestamp.fromDate(eventStartDate)
        event.eventStart = timestamp

        let eventRef = await firebase.firestore().collection(`events`).doc(this.selectedEvent)
        await eventRef.update(event)
        
        this.message = "Updated"

        setTimeout(() => {
          this.message = null
        }, 2500)
      }
    },
    async mounted() {
      await this.$bind("events", firebase.firestore().collection(`events`).orderBy("eventStart"))
      this.loading = false
    }
  }
</script>